import { asyncRoute } from '../../router';

export default asyncRoute(() => import(/* webpackChunkName: "SignUpContainer" */ './components/SignUp'));
